import React, { Component } from 'react';
import { withFirebase } from '../HOCs';

const withFirestore = WrappedComponent => {
  class WithFirestore extends Component {
    constructor(props) {
      super(props);
    }

    render() {
      return (
        <WrappedComponent
          firestore={this.props.firebase.firestore()}
          {...this.props}
        />
      );
    }
  }
  return withFirebase(WithFirestore);
};

export default withFirestore;
